// @ts-nocheck
import React from 'react';

export const PrivacyPage = () => {
    return (
        <div className="max-w-4xl mx-auto px-4 py-8">
            <div className="bg-gray-900/50 backdrop-blur-md rounded-2xl p-8 border border-white/10 shadow-2xl">
                <h1 className="text-4xl font-bold text-white mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">Privacy Policy</h1>
                <p className="text-gray-400 mb-2 italic">Last Updated: January 17, 2026</p>
                <p className="text-xs text-gray-500 font-mono mb-8 select-all">tiktok-developers-site-verification=BNC51ANOyDFWpdYFS6eFrWH3nXcNXhL1</p>

                <div className="space-y-8 text-gray-200">
                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                            <span className="w-8 h-8 rounded-lg bg-blue-500/20 flex items-center justify-center text-blue-400 text-sm">01</span>
                            Information We Collect
                        </h2>
                        <div className="pl-10 space-y-3">
                            <p><strong className="text-blue-300">Account Information:</strong> We collect your username, email address, and password when you create an account.</p>
                            <p><strong className="text-blue-300">Profile Data:</strong> We store your display name, bio, profile pictures, and personalized background settings.</p>
                            <p><strong className="text-blue-300">Content:</strong> This includes posts, comments, likes, bookmarks, and direct messages you share on the platform.</p>
                        </div>
                    </section>
                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                            <span className="w-8 h-8 rounded-lg bg-purple-500/20 flex items-center justify-center text-purple-400 text-sm">02</span>
                            How We Use Information
                        </h2>
                        <p className="pl-10">We use your data to maintain your social graph, enable real-time messaging, provide personalized themes, and track your "Digital Footprint" through achievements and streaks.</p>
                    </section>
                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                            <span className="w-8 h-8 rounded-lg bg-green-500/20 flex items-center justify-center text-green-400 text-sm">03</span>
                            Data Sharing
                        </h2>
                        <p className="pl-10">Your profile and public posts are visible to other users. We do not sell your personal data to third parties. Data is shared with service providers only as necessary to operate the service.</p>
                    </section>
                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                            <span className="w-8 h-8 rounded-lg bg-red-500/20 flex items-center justify-center text-red-400 text-sm">04</span>
                            Security and Privacy
                        </h2>
                        <p className="pl-10">We use industry-standard encryption for data at rest and in transit. You can control your visibility through the "Private Profile" setting and manage notification preferences in your settings.</p>
                    </section>
                </div>

                <div className="mt-12 pt-8 border-t border-white/5 text-center">
                    <p className="text-gray-500 text-sm mb-6">If you have questions, please reach out via the official Digital Footprint support channels.</p>
                    {!localStorage.getItem('currentUser') && (
                        <button
                            onClick={() => window.location.pathname = '/'}
                            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full transition-colors"
                        >
                            Back to Login
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export const SafetyPage = () => {
    return (
        <div className="max-w-4xl mx-auto px-4 py-8">
            <div className="bg-gray-900/50 backdrop-blur-md rounded-2xl p-8 border border-white/10 shadow-2xl">
                <h1 className="text-4xl font-bold text-white mb-6 bg-gradient-to-r from-red-400 to-orange-400 bg-clip-text text-transparent">Safety Standards</h1>
                <p className="text-gray-400 mb-8 italic">Commitment to a Safe Community</p>

                <div className="space-y-8 text-gray-200">
                    <section className="p-6 bg-red-500/10 rounded-xl border border-red-500/20">
                        <h2 className="text-2xl font-semibold text-red-400 mb-4 flex items-center gap-2">
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>
                            Zero Tolerance Policy: CSAE
                        </h2>
                        <p className="text-gray-200 leading-relaxed">
                            Digital Footprint has a <strong>zero-tolerance policy</strong> regarding Child Sexual Abuse and Exploitation (CSAE). Any user found hosting, sharing, or promoting such content will have their account permanently terminated without warning.
                        </p>
                    </section>
                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                            <span className="w-8 h-8 rounded-lg bg-orange-500/20 flex items-center justify-center text-orange-400 text-sm">01</span>
                            Prohibited Content
                        </h2>
                        <div className="pl-10 space-y-3">
                            <p>We strictly prohibit any content that depicts, encourages, or facilitates the sexual exploitation of minors. This includes, but is not limited to, predatory grooming behavior.</p>
                        </div>
                    </section>
                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                            <span className="w-8 h-8 rounded-lg bg-blue-500/20 flex items-center justify-center text-blue-400 text-sm">02</span>
                            Automatic Detection & Reporting
                        </h2>
                        <p className="pl-10">We employ automated tools and human review to identify and remove prohibited content. We report all instances of CSAE to the National Center for Missing & Exploited Children (NCMEC).</p>
                    </section>
                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                            <span className="w-8 h-8 rounded-lg bg-yellow-500/20 flex items-center justify-center text-yellow-400 text-sm">03</span>
                            Community Reporting
                        </h2>
                        <p className="pl-10">Users are encouraged to use the "Report" feature. Reports are reviewed by our safety team with high priority.</p>
                    </section>
                </div>

                <div className="mt-12 pt-8 border-t border-white/5 text-center">
                    <p className="text-gray-500 text-sm mb-6">If you encounter immediate danger, please contact your local emergency services.</p>
                    {!localStorage.getItem('currentUser') && (
                        <button
                            onClick={() => window.location.pathname = '/'}
                            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full transition-colors"
                        >
                            Back to Login
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};
